<template>
  <i-select
    ref="select"
    :value="value"
    :filterable="true"
    v-on="$listeners"
    @on-open-change="on_open_change"
  >
    <i-option v-for="z in timezones" :key="z.name" :value="z.name" :label="z.description" />
  </i-select>
</template>

<script>
  import { TimeZoneHelper } from '@shared/helpers/timezone';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    computed: {
      timezones: function() {
        return TimeZoneHelper.getList();
      }
    },

    methods: {
      on_open_change: function(is_open) {
        if (is_open) {
          try {
            const $select = this.$refs.select.$el;
            const $dropdown = $select.getElementsByClassName('ivu-select-dropdown')[0];
            const elements = $select.getElementsByClassName('ivu-select-item-selected');

            if (elements.length) {
              this.$nextTick(() => {
                $dropdown.scrollTop = elements[0].offsetTop;
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
      }
    }
  };
</script>
